import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/shared/Navigation';
import Footer from '../components/shared/Footer';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { AlertCircle } from 'lucide-react';

export default function PaymentCancelPage() {
  return (
    <div>
      <Navigation />
      
      <div className="container section-spacing max-w-2xl">
        <Card>
          <CardHeader className="text-center">
            <div className="mx-auto w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4">
              <AlertCircle className="h-8 w-8 text-orange-600" />
            </div>
            <CardTitle className="text-3xl font-[var(--font-display)]">
              Payment Cancelled
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-6">
              <div className="bg-muted p-6 rounded-lg text-center">
                <p className="text-muted-foreground">
                  Your payment was not completed. No charges were made to your account.
                </p>
              </div>

              <div className="bg-blue-50 border border-blue-200 p-4 rounded-lg">
                <h3 className="font-semibold mb-2">Need Help?</h3>
                <p className="text-sm text-muted-foreground mb-3">
                  If you encountered any issues or have questions about the payment process, please contact us.
                </p>
                <Link to="/contact">
                  <Button variant="outline" size="sm" className="rounded-[var(--btn-radius)]">
                    Contact Us
                  </Button>
                </Link>
              </div>

              <div className="flex gap-4">
                <Link to="/units" className="flex-1">
                  <Button variant="outline" className="w-full rounded-[var(--btn-radius)]">
                    Browse Units
                  </Button>
                </Link>
                <Button
                  data-testid="payment-retry-button"
                  onClick={() => window.history.back()}
                  className="flex-1 bg-[#A06A3B] text-[#FBF8F2] hover:bg-[#6F4526] rounded-[var(--btn-radius)]"
                >
                  Try Again
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      <Footer />
    </div>
  );
}